<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)"></app-success-generico>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>

@if (alertIncluirEndereco) {
  <div class="body-alert">
    <div class="div-alert">
      <p class="titulo-alert text-start">Inclusão de Endereco</p>
      <app-endereco-form
        [formulario]="formulario"
        [consultaCep]="consultaCep"
        [mensagemErro]="mensagemErro">
      </app-endereco-form>
      <div class="col-12 ps-0">
        <div class="row">
          <div class="col-12 col-md-6 text-end">
            <button class="botao-outline" id="inptFecharEndereco" (click)="cancelarIncluirEndereco()">FECHAR</button>
          </div>
          <div class="col-12 col-md-6 text-start">
            <button class="botao" id="inptSalvarEndereco" (click)="adicionarEndereco()"
              [ngClass]="{ 'disabled': !formulario.valid }"
              [disabled]="!formulario.valid"
              data-bs-toggle="tooltip" data-placement="top"
            title="Preencha todos os campos obrigatórios.">SALVAR</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
